import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FooterItem from './FooterItem';

import './Footer.scss';

class Footer extends Component {
  static displayName = 'Footer';
  static propTypes = {
    iconClass: PropTypes.string,
    title: PropTypes.string
  };
  render() {
    return (
      <footer>
        <div className='footer-line'>
          <FooterItem title={["adam.t.schaal@gmail.com"]}
            iconClass="fa fa-envelope"/>
          <FooterItem title={[{ label: "/in/adamschaal", href: "https://linkedin.com/in/adamschaal" }]}
            iconClass="fa fa-linkedin"
            links/>
          <FooterItem title={[{ label: "@clevernyyyy", href: "https://x.com/clevernyyyy" }]}
            iconSvgPath="M18.244 2H21.5l-7.11 8.13L22.75 22h-6.54l-5.12-6.7L5.2 22H1.94l7.6-8.7L1.25 2h6.7l4.63 6.11L18.244 2Zm-1.15 18h1.8L6.95 3.9H5.02L17.09 20Z"
            links/>
          <FooterItem title={[{ label: "/clevernyyyy", href: "https://github.com/clevernyyyy" }]}
            iconClass="fa fa-github"
            links/>
          <FooterItem title={[{ label: "adamschaal.com", href: "https://adamschaal.com" }]}
            iconClass="fa fa-window-maximize"
            links/>
        </div>
      </footer>
    );
  }
}

export default Footer;
